// IntegrationsPage.tsx - Integrations management page
import { Container, Title, Text, Stack } from '@mantine/core';
import { IntegrationManager } from '@/components/integrations/IntegrationManager';

export function IntegrationsPage() {
  return (
    <Container size="xl" py="xl">
      <Stack gap="lg">
        <div>
          <Title order={1}>Integrations</Title>
          <Text c="dimmed" mt="xs">
            Connect and manage external data sources
          </Text>
        </div>
        <IntegrationManager />
      </Stack>
    </Container>
  );
}
